import apiClient from './client';
import type { ViewBody } from '../../components/DataLibrary/savedViews';

/** MDF-38: one saved Data Library view of the signed-in user. */
export interface DataLibrarySavedView {
  id: string;
  tab: string;
  name: string;
  /** Untrusted: read it through resolveView */
  body: unknown;
  created_at: string;
  updated_at: string;
}

const BASE = '/api/data-library/saved-views';

export const dataLibrarySavedViewsApi = {
  list: (tab: string) => apiClient.get<DataLibrarySavedView[]>(BASE, { tab }),
  create: (tab: string, name: string, body: ViewBody) =>
    apiClient.post<DataLibrarySavedView>(BASE, { tab, name, body }),
  update: (id: string, changes: { name?: string; body?: ViewBody }) =>
    apiClient.patch<DataLibrarySavedView>(`${BASE}/${id}`, changes),
  delete: (id: string) => apiClient.delete<void>(`${BASE}/${id}`),
};
